import { GenericDisplayable } from '../../legacy/objects/generic/displayable/generic-displayable';

import { OrgConstructor } from './org-constructor';
import { OrgSchema } from './org-schema';
import { WidgetMode } from './widget-mode';

export class Org extends GenericDisplayable {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected widgetMode!: WidgetMode;
  protected enableOnPaths!: string[] | undefined;
  protected canAttachToDOM!: boolean;
  protected includedTrafficPercent!: number | undefined;
  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(constructor: OrgConstructor) {
    super(constructor);
  }

  /////////////////////////////////////////////////////////////////////////////
  // Get Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): OrgSchema {
    return new OrgSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(Org.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  protected static _deserialize(validationResult: import('joi').ValidationResult): Org {
    return new Org(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getWidgetMode(): WidgetMode {
    return this.widgetMode;
  }

  public getEnableOnPaths() {
    return this.enableOnPaths;
  }

  public getCanAttachToDOM() {
    return this.canAttachToDOM;
  }

  public getIncludedTrafficPercent() {
    return this.includedTrafficPercent ?? 5;
  }
}
